import { FunctionComponent, MouseEvent, useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, createStyles, makeStyles, Theme, ClickAwayListener, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

export interface Props extends PropsWithChildren {
    id?: string;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        containerDropDown: {
            display: 'flex',
            position: 'relative'
        },
        dropdown: {
            top: 50,
            left: 0,
            width: 'max-content',
            borderRadius: 14,
            padding: '10px 0px',
            position: 'absolute',
            backgroundColor: '#fff',
            border: 'solid 1px #000',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column'
        },
        dropdownCloseToBottom: {
            top: 'auto',
            bottom: 30
        },
        dropdownItemsContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        icon: {
            cursor: 'pointer'
        },
        addService: {
            cursor: 'pointer',
            color: '#92B4A7',
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '27px',
            paddingTop: 10
        },
        leftSpace: {
            paddingLeft: '5px'
        }
    })
);

function checkIfCloseToBottom(element: HTMLElement, threshold = 100): boolean {
    if (element) {
        const rect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        return rect.bottom >= viewportHeight - threshold;
    }

    return false;
}

export const AddButton: FunctionComponent<Props> = props => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const [isCloseToBottom, setIsCloseToBottom] = useState(false);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const clickToolbarButtonHandler = (event: MouseEvent): void => {
        setShow(prev => {
            return !prev;
        });
    };

    useEffect(() => {
        window.addEventListener(
            'scroll',
            () => {
                setIsCloseToBottom(checkIfCloseToBottom(dropdownRef.current!));
            },
            true
        );
    }, []);

    return (
        <ClickAwayListener onClickAway={() => setShow(false)}>
            <div
                ref={dropdownRef}
                className={clsx(classes.containerDropDown, props.className)}
                onClick={clickToolbarButtonHandler}
            >
                <Box
                    className={classes.icon}
                    id={props.id && props.id.concat('_toolbar_button')}
                >
                    <Typography className={classes.addService}>
                        Add
                        {show ? (
                            <FontAwesomeIcon
                                className={clsx(classes.addService, classes.leftSpace)}
                                icon={faChevronUp}
                            />
                        ) : (
                            <FontAwesomeIcon
                                className={clsx(classes.addService, classes.leftSpace)}
                                icon={faChevronDown}
                            />
                        )}
                    </Typography>
                </Box>

                {show && (
                    <ClickAwayListener onClickAway={() => setShow(false)}>
                        <Box
                            className={clsx(classes.dropdown, {
                                [classes.dropdownCloseToBottom]: isCloseToBottom
                            })}
                            id={props.id && props.id.concat('_toolbar_list')}
                        >
                            {props.children}
                        </Box>
                    </ClickAwayListener>
                )}
            </div>
        </ClickAwayListener>
    );
};

export default AddButton;
